import { FaStar } from "react-icons/fa";

const Banner = () => {
  const stars = Array.from({ length: 5 }, (_, i) => (
    <li key={i}>
      <FaStar className="text-yellow-400" />
    </li>
  ));

  return (
    <div className="text-center  min-w-screen py-20 text-white px-4">
      <h2 className="text-[40px] mb-4">Win More Customers</h2>
      <p className="text-lg opacity-75 mb-6 italic">
        “A Critical Challenge for Businesses”
      </p>
      <div className="inline-flex items-center">
        <ul className="flex space-x-1">{stars}</ul>
        <div className="text-base ml-4">
          <strong className="font-medium">5.0</strong>{" "}
          <span className="opacity-50">(10k businesses)</span>
        </div>
      </div>
    </div>
  );
};

export default Banner;
